import { useContext } from 'react';

import { PrivateEchoWebsocketService } from '../../services/PrivateEchoWebsocketService';
import { WebsocketContext } from '../../WebsocketContext';

export const usePrivateWebsocketService = (): PrivateEchoWebsocketService => {
  const { privateWebsocketService } = useContext(WebsocketContext);

  if (!privateWebsocketService) {
    throw new Error('Private Websocket Service has not been initialized');
  }

  return privateWebsocketService;
};
